import { SendFormData, wclValidateForm, wclValidateField, hideAlertMessageOnFocus } from "../../wcl-helpers";

document.addEventListener('DOMContentLoaded', () => {

   if (document.querySelector('.wcl-modal-confirm-code')) {
      const form = document.querySelector('.wcl-modal-confirm-code');
      const modalFormWrapper = form.closest('.wcl-modal-inner');
      const modalLayout = form.closest('.wcl-modal-layout');
      const inputsList = form.querySelectorAll('.wcl-code-inputs input');
      const modalMainPopup = document.querySelector('#wcl-popup');

      // Get variables
      // const wpnonce = form.querySelector('#wcl_confirm_code_wpnonce');
      const submitBtn = form.querySelector('#wcl-js-confirm-code');

      //Email Confirmation Modal
      const modalConfirmation = document.getElementById('wcl-modal-confirm-successful');

      //Forgot Password Modal
      const forgorPasswordModal = document.querySelector('#wcl-forgot-password-popup');

      // Get UI element
      const messageBlock = form.querySelector('.wcl-message-alert');
      const message = messageBlock.querySelector('.wcl-message');

      submitBtn.addEventListener('click', e => {
         e.preventDefault();

         const userId = form.dataset.userId;
         const userCodeType = form.dataset.codeType;

         messageBlock.classList.remove('show', 'error', 'success');

         // Validation
         if (!wclValidateForm(form)) {
            return;
         }

         let secretCode = '';

         inputsList.forEach(input => {
            secretCode += input.value;
         });

         modalFormWrapper.classList.add('loading');

         let formData = new FormData(form);

         // Add wpnonce to data array
         // formData.append('wpnonce', wpnonce.value);
         formData.append('secret_code', secretCode);
         formData.append('user_id', userId);
         formData.append('code_type', userCodeType);

         SendFormData('confirm_code', formData).then(function (res) {
            modalFormWrapper.classList.remove('loading');

            let response = JSON.parse(res);

            if (response.success == '1') {
               if (response.code_type === 'registration') {
                  //Account Details Modal
                  const modalAccountDetails = document.getElementById('wcl-accound-details-popup');
                  const modalAccountDetailsForm = modalAccountDetails.querySelector('.wcl-modal-account-details-form');

                  //Hide current modal layout
                  modalLayout.classList.remove('active');

                  //Show modal "Email Confirmed" after verify code for registration
                  modalConfirmation.classList.add('active');

                  //Set data-user-id attr for confirm code form
                  modalAccountDetailsForm.setAttribute('data-user-id', userId);
                  // modalAccountDetailsForm.setAttribute('data-code-type', codeType);

               } else if (response.code_type === 'verify') {
                  //Successful Verification Modal
                  const modalSuccessfullVerification = document.getElementById('wcl-modal-confirm-successful');
                  const modalSuccessfullVerificationLabel = modalSuccessfullVerification.querySelector('.wcl-modal-top');

                  //Hide current modal layout
                  modalLayout.classList.remove('active');

                  //Show modal "Successful Verification" after verify code for profile
                  modalSuccessfullVerification.classList.add('active');

                  //Hide Modal Label
                  modalSuccessfullVerificationLabel.style.display = "none";

                  //Page reload
                  setTimeout(function () {
                     window.location.reload();
                  }, 1500);
               } else if (response.code_type === 'forgot_password') {
                  //Set New Password Modal
                  const setNewPasswordModal = document.querySelector('#wcl-set-new-password-popup');
                  const setNewPasswordForm = setNewPasswordModal.querySelector('.wcl-modal-form-set-new-password');
                  const setNewPasswordUserEmail = setNewPasswordModal.querySelector('#wcl-set-password-email');

                  //Get User Email from from the response
                  const userEmail = response.email;

                  //Hide current modal layout
                  modalLayout.classList.remove('active');
                  forgorPasswordModal.classList.remove('active');

                  //Show "Set New Password" Modal after verify code for forgot_password
                  modalMainPopup.classList.add('active');
                  setNewPasswordModal.classList.add('active');

                  //Set data-user-id attr for confirm code form
                  setNewPasswordForm.setAttribute('data-user-id', userId);

                  //Show current user email
                  setNewPasswordUserEmail.textContent = userEmail;
               }
            } else {
               throw response.message;
            }

         }).catch(function (err) {
            // Error
            modalFormWrapper.classList.remove('loading');

            messageBlock.classList.add('show', 'error');
            message.innerHTML = err;

            hideAlertMessageOnFocus(form, messageBlock);
         });
      });

   }
});